import faviconSvg from "@/assets/images/favicon.svg?raw";
import { appEnvironmentAccent } from "@/config";

/**
 * Retints the Handraise favicon for non-production environments.
 * No-op when {@link appEnvironmentAccent} is null (production).
 */
export const applyEnvironmentFavicon = () => {
  if (appEnvironmentAccent == null) return;

  const links = document.querySelectorAll<HTMLLinkElement>('link[rel~="icon"]');
  if (links.length === 0) return;

  const tinted = faviconSvg
    .replace(
      'fill="#ffffff"',
      `fill="${appEnvironmentAccent.faviconBackgroundColor}"`,
    )
    .replace(
      'fill="black"',
      `fill="${appEnvironmentAccent.faviconForegroundColor}"`,
    );
  const href = URL.createObjectURL(
    new Blob([tinted], { type: "image/svg+xml" }),
  );

  for (const link of links) {
    link.type = "image/svg+xml";
    link.href = href;
  }
};
